export default __webpack_public_path__ + "./fonts/checkboxContract.f85c2dbe.svg";